const TableData = (props) => {
  const { children, width } = props;
  return (
    <td className="linkTableRows" style={{ width }}>
      <div className="linkTableMargin">{children}</div>
    </td>
  );
};
export default TableData;
